
























import App from './scripts';

export default App;
